import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';

export const DownloadInProgress = () => {
  const { t } = useTranslation('analytics-reporting');

  return (
    <div css={styles.wrapper}>
      <div className='icon-wrapper'>
        <Icon color='primary' name='clock' size={32} />
      </div>
      <Text size='large' weight='bold'>
        {t('Generating Report')}
      </Text>
      <Text color='subdued' size='small' textAlign='center'>
        {t('Please wait while we compile your analytics data')}
      </Text>
    </div>
  );
};

const styles = {
  wrapper: css`
    align-items: center;
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: center;

    .icon-wrapper {
      align-items: center;
      background-color: ${theme.colors.primary5};
      border-radius: 50%;
      display: flex;
      height: ${theme.spacing(6)};
      justify-content: center;
      margin-bottom: ${theme.spacing(2)};
      width: ${theme.spacing(6)};
  `,
};
